module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "horizontal": "",
      "label": "Subject",
      "type": "is-danger",
      "message": "Please enter a subject"
    }
  }, [_c('b-input', {
    attrs: {
      "name": "subject",
      "expanded": ""
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "horizontal": "",
      "label": "From"
    }
  }, [_c('b-input', {
    attrs: {
      "name": "name",
      "placeholder": "Name",
      "expanded": ""
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "nobody@nowhere.com",
      "expanded": ""
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "horizontal": "",
      "label": "Topic"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a topic"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Bulma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Vue.js")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Buefy")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "horizontal": "",
      "label": "Message"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "textarea"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "horizontal": ""
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("\n                  Send message\n                ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d40a6b4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/field/examples/ExHorizontal.vue
// module id = 1082
// module chunks = 5 223